const aspectsRules = {
  Su: [7],
  "(Su)": [7],
  Mo: [7],
  "(Mo)": [7],
  Me: [7],
  "(Me)": [7],
  Ve: [7],
  "(Ve)": [7],
  Ma: [4, 7, 8],
  "(Ma)": [4, 7, 8],
  Ju: [5, 7, 9],
  "(Ju)": [5, 7, 9],
  Sa: [3, 7, 10],
  "(Sa)": [3, 7, 10],
  "(Ra)": [5, 9],
  "(Ke)": [5, 9],
};

export const calculateAspect = (key, num) => {
  num = parseInt(num); // Convert num to an integer
  return aspectsRules[key]
    ? aspectsRules[key].map((val) => (val + num - 1) % 12 || 12)
    : [];
};
